import type { Configuration } from '@gov-nx/api';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';
import type { ConfigurationState } from './store.types';

const initialState = {
	cmsUrlPath: 'https://podnikatel.egov-dev-ace.com/cms-prod',
};

const useStore = <T>(selector: (state: ConfigurationState) => T) =>
	usePersistedStore(
		(set) => ({
			...initialState,
			saveConfiguration: (configuration: Configuration) =>
				set({ configuration }),
		}),
		'configuration',
		selector
	);

export const useConfigurationStore = <T extends keyof ConfigurationState>(
	property: T
): ConfigurationState[T] => useStore(prop(property));

export const useCmsUrlPath = () => {
	const cmsUrlPath = useConfigurationStore('cmsUrlPath');
	const {
		extraConfig: { application, environment },
	} = useExtraConfigContext();

	const baseCmsUrlPath = String(cmsUrlPath).includes('https')
		? cmsUrlPath
		: application === 'po' || application === 'gov'
			? 'https://obcan.portal.gov.cz/cms'
			: 'https://portalpodnikatele.gov.cz/cms';

	const finalCmsUrlPath = String(cmsUrlPath).includes('https')
		? cmsUrlPath
		: application === 'po' || application === 'gov'
			? 'https://obcan.portal.gov.cz/cms'
			: 'https://portalpodnikatele.gov.cz/cms';

	return {
		cmsUrlPath: `${finalCmsUrlPath}/${application}/${environment}`,
		baseCmsUrlPath,
	};
};
